import { configureStore } from '@reduxjs/toolkit';
import sliderReducer from '../features/Slider/SliderSlice';
import settingReducer from '../features/Setting/setting';
import activityReducer from '../features/Activity/Activity';
import statisticsReducer from '../features/Statistics/Statistics';
import DoctorReducer from '../features/Doctors/Doctor';
import galleryReducer from '../features/Gallery/Gallery';
import publishmentReducer from '../features/publishments/publishment';
import showPublishmentReducer from '../features/publishments/ShowPublishment';
import showActivityReducer from '../features/Activity/ShowActivity';
import showDoctorsReducer from '../features/Doctors/ShowDoctors';
import settingIconReducer from '../features/Setting/Icons';
import ourStoryReducer from '../features/OurStory/ourStory';
import settingContactReducer from '../features/Setting/contact';
import caseReducer from '../features/CaseReducer/CaseReducer';
import showCaseReducer from '../features/CaseReducer/showCaseReducer';
import branchReducer from '../features/Branches/BranchSlice';
import aidReducer from '../features/AidSlice/AidSlice';
import projectReducer from '../features/ProjectSlice/ProjectSlice';
import showProjectReducer from '../features/ProjectSlice/ShowProjectSlice';
import aboutReducer from '../features/AboutSlice/AboutSlice';
import showAboutReducer from '../features/AboutSlice/ShowAboutSlice';
import fetchCurrencyReducer from '../features/CurrencySlice/CurrencySlice';
import fetchCountryReducer from '../features/CountrySlice/CountrySlice';
import fetchUnitReducer from '../features/UnitSlice/UnitSlice';
import showUnitReducer from '../features/UnitSlice/ShowUnitSlice'
import blogReducer from '../features/BlogSlice/BlogSlice';
import branchServerReducer from '../features/Branches/getBranchServerSlice';
import branchInfoReducer from '../features/Branches/ShowBranchInfo';
import showBranchInfoReducer from '../features/Branches/ShowInfo';
import featchsearchReducer from '../features/Activity/SearchActivity';
export const store = configureStore({
  reducer: {
    slider: sliderReducer,
    setting: settingReducer,
    icons: settingIconReducer,
    activity: activityReducer,
    showActivity: showActivityReducer,
    statistics: statisticsReducer,
    doctors: DoctorReducer,
    showDoctors: showDoctorsReducer,
    gallery: galleryReducer,
    publishments: publishmentReducer,
    showPublishment: showPublishmentReducer,
    ourStory: ourStoryReducer,
    settingContact: settingContactReducer,
    case: caseReducer,
    showCase: showCaseReducer,
    branches: branchReducer,
    aid: aidReducer,
    project: projectReducer,
    showProject: showProjectReducer,
    about: aboutReducer,
    showAbout: showAboutReducer,
    fetchCurrency: fetchCurrencyReducer,
    fetchCountry: fetchCountryReducer,
    fetchUnit: fetchUnitReducer,
    showUnit: showUnitReducer,
    blog: blogReducer,
    branchServer: branchServerReducer,
    branchInfo: branchInfoReducer,
    showBranchInfo: showBranchInfoReducer,
    featchSearchActivity: featchsearchReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ['payload'],

      },
    }),
});